"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _getStylesCreator.default;
  }
});

var _getStylesCreator = _interopRequireDefault(require("./getStylesCreator"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/getStylesCreator/index.js
// module id = 907
// module chunks = 0